'use client';

import { useEffect, useState } from 'react';
import { getSettings } from '@/lib/actions/settings';
import { SettingsForm } from '@/components/admin/settings/SettingsForm';

export default function AdminSettingsPage() {
  const [settings, setSettings] = useState<Awaited<ReturnType<typeof getSettings>> | null>(null);

  useEffect(() => {
    getSettings().then(setSettings);
  }, []);

  if (!settings) {
    return null;
  }

  return <SettingsForm initialData={settings} />;
}
